import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent implements AfterViewInit  {
  private text = 'REDMED საქართველოში პირველი ინოვაციური სამედიცინო ეკოსისტემაა, რომელიც შენი და შენი ოჯახის წევრების ჯანმრთელობაზე\n' +
    '    ზრუნვას გაგიმარტივებს.\n' +
    '    თანამედროვე ადამიანისთვის განსაკუთრებით მნიშვნელოვანია დროის ოპტიმალურად მართვა, სწორედ ამიტომ ჩვენ შევქმენით\n' +
    '    პლატფორმა, რომელიც საჭირო ადამიანებს ერთმანეთთან აკავშირებს. მომხმარებელს შეუძლია ექიმს, ყველაზე კომფორტულ გარემოში,\n' +
    '    სახლში შეხვდეს ან მიიღოს ექიმის რჩევა ონლაინ : სატელეფონო ან ვიდეო ზარით.';

  constructor(private title: Title,
              private meta: Meta,
              private translate: TranslateService) {
  }

  ngAfterViewInit () {
    this.translate.get('i-use-redmed').subscribe(event => {
      this.title.setTitle(this.translate.instant('about-us') + ' - Redmed');
      this.meta.addTags([
        {
          property: 'og:description',
          content: this.text.substring(0, 200)
        },
        {
          property: 'description',
          content: this.text.substring(0, 200)
        },
        {
          name: 'description',
          content: this.text.substring(0, 200)
        },
      ]);
    })
  }

}
